import { Star } from "lucide-react";

export default function MarkedMomentsList({ moments }) {
  return (
    <section
      data-testid="marked-moments-section"
      className="bg-white border-2 border-yellow-300 rounded-xl p-5 shadow-sm"
    >
      <header className="flex items-center justify-between mb-3 pb-3 border-b border-yellow-100">
        <div className="flex items-center gap-2">
          <Star className="h-4 w-4 text-yellow-600 fill-yellow-500" />
          <h3 className="font-display text-xs font-semibold uppercase tracking-widest text-yellow-900">
            Marked Moments
          </h3>
        </div>
        <span className="font-mono text-xs text-yellow-700">{moments.length}</span>
      </header>

      <ul className="space-y-2.5">
        {moments.length === 0 && (
          <li className="text-xs text-slate-400 italic">
            Tap MARK MOMENT to flag anything important the closer wants to remember.
          </li>
        )}
        {moments.map((m) => (
          <li
            key={m.id}
            data-testid="marked-moment-item"
            className="sch-fade-in rounded-lg bg-yellow-50 border border-yellow-200 px-3 py-2.5"
          >
            <div className="text-sm text-yellow-950 font-medium leading-snug">&ldquo;{m.quote}&rdquo;</div>
            {m.context && (
              <div className="mt-1 text-[11px] text-slate-600 line-clamp-2">{m.context}</div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
